import { ChangeDetectionStrategy, Component, Type } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  FieldType,
  FieldTypeConfig,
  FormlyFieldConfig,
  FormlyModule,
} from '@ngx-formly/core';
import { FormlyFieldProps } from '@ngx-formly/primeng/form-field';
import { SelectWithLazy } from '../../components';

export interface SelectLazyProps extends FormlyFieldProps {
  /** Server-side qidiruv endpoint'i, masalan 'spinstitutions/get-paged'. */
  apiUrl: string;
  /** Backend filteriga yuboriladigan qidiruv maydoni (default 'search'). */
  searchFieldName?: string;
  /** Option value maydoni (default 'value'). */
  optionValue?: string;
  /** Option label maydoni (default 'label'). `multiLang` bo'lsa hisobga olinmaydi. */
  optionLabel?: string;
  /** Ko'p tilli `name` ({ uz, ru, ... }) bo'lsa true. */
  multiLang?: boolean;
  /** Label'ni transloco orqali tarjima qilish. */
  translate?: boolean;
  /** Doimiy qo'shimcha filtrlar. */
  defaultFilters?: { [key: string]: { value: string } };
  /** Qidiruv qamrovi, masalan 'name.uz,name.ru,name.en,name.kaa'. */
  filterFields?: string;
  styleClass?: string;
}

export interface FormlySelectLazyFieldConfig
  extends FormlyFieldConfig<SelectLazyProps> {
  type: 'select-lazy' | Type<TypeSelectLazy>;
}

/**
 * Formly `select-lazy` turi — `lib-select-with-lazy` (virtual scroll + server-side
 * qidiruv) ustida. Katta ma'lumotnomalar (masalan `spinstitutions`, 12k+) uchun:
 * to'liq yuklamaydi, har qidiruvda backend'ga so'rov yuboradi.
 *
 *   {
 *     key: 'organizerInstitutionId',
 *     type: 'select-lazy',
 *     templateOptions: {
 *       label: 'organizerInstitutionName',
 *       apiUrl: 'spinstitutions/get-paged',
 *       optionValue: 'id',
 *       multiLang: true,
 *     },
 *   }
 */
@Component({
  selector: 'lib-type-select-lazy',
  standalone: true,
  imports: [ReactiveFormsModule, FormlyModule, SelectWithLazy],
  template: `
    <lib-select-with-lazy
      [formControl]="formControl"
      [formlyAttributes]="field"
      [virtualScroll]="true"
      [api_url]="props.apiUrl"
      [searchFieldName]="props.searchFieldName ?? 'search'"
      [optionValue]="props.optionValue ?? 'value'"
      [optionLabel]="props.optionLabel ?? 'label'"
      [isMultiLang]="!!props.multiLang"
      [isTranslated]="!!props.translate"
      [placeholder]="props.placeholder ?? ''"
      [showClear]="!props.required"
      [filterFields]="props.filterFields ?? ''"
      [defaultSearchFieldName]="props.defaultFilters"
      [styleClass]="props.styleClass ?? 'w-full'"
    />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TypeSelectLazy extends FieldType<
  FieldTypeConfig<SelectLazyProps>
> {}
